
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter } from "react-router-dom";
import Select from "react-select";
import { Alert } from "reactstrap";

import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Button,
  Input,
} from "reactstrap";

import { getcyclelist } from "store/cycle/actions";

import {
  getpartpayment,
  addremainingpayment,
} from "store/registration-admin/actions";

// Used to populate AddPayment.csr_staff
import {
  getParticipantSchemelist,
} from "store/Payment/actions";

import {
  Formik,
  Field,
  Form,
  ErrorMessage,
} from "formik";

import * as Yup from "yup";

import "assets/scss/table.scss";

class PartialPayment extends Component {
  constructor(props) {
    super(props);

    const selectedParticipant =
      (this.props.location &&
        this.props.location.state &&
        this.props.location.state
          .selectedParticipant) ||
      {};

    this.state = {
      selectedParticipant,

      AllLabs: [],
      selectedScheme: null,

      paymentType: "partial",

      id: "",
      btnText: "Copy",

      organization_name: "",

      tooltipContent: [
        "Worst",
        "Bad",
        "Average",
        "Good",
        "Excellent",
      ],

      filteredLabs: [],
      CycleList: [],

      selectedParticipantType:
        "All Participant",

      user_id: localStorage.getItem(
        "authUser"
      )
        ? JSON.parse(
            localStorage.getItem(
              "authUser"
            )
          ).user_id
        : "",

      successMessage: "",

      localPartPaymentData: null,
    };
  }

  componentDidMount() {
    console.log(
      "Fetching data...",
      this.state.selectedParticipant
    );

    const authUser =
      localStorage.getItem("authUser");

    const user_id = authUser
      ? JSON.parse(authUser).user_id
      : null;

    if (!user_id) {
      console.error(
        "User ID is missing. Cannot proceed with API calls."
      );

      return;
    }

    console.log(
      "Retrieved user_id:",
      user_id
    );

    this.setState(
      { user_id },
      () => {
        const {
          organization_name,
        } = this.props.match.params || {};

        console.log(
          "organization_name from props:",
          organization_name
        );

        if (organization_name) {
          this.setState(
            {
              organization_name,
            },
            () => {
              console.log(
                "Organization name set:",
                this.state
                  .organization_name
              );

              this.fetchData(
                this.state.user_id
              );
            }
          );
        } else {
          console.error(
            "Organization name is missing in URL parameters."
          );
        }
      }
    );
  }

  fetchData = (user_id) => {
    const participantId =
      this.state.selectedParticipant &&
      this.state.selectedParticipant.id;

    console.log(
      "Participant ID sent to API:",
      participantId
    );

    if (!participantId) {
      console.error(
        "ERROR: selectedParticipant.id is missing!"
      );

      return;
    }

    // Get existing payment information
    this.props.onGetpartpayment(
      participantId
    );

    // Get cycle list
    this.props.ongetcyclelist(
      user_id
    );

    // Get CSR list
    this.props.onGetParticipantPayment(
      user_id
    );
  };

  componentDidUpdate(
    prevProps,
    prevState
  ) {
    if (
      prevState.filteredLabs !==
      this.state.filteredLabs
    ) {
      console.log(
        "FilteredLabs updated:",
        this.state.filteredLabs
      );
    }

    if (
      prevProps.CycleList !==
      this.props.CycleList
    ) {
      console.log(
        "Updating CycleList in state:",
        this.props.CycleList
      );

      this.setState({
        CycleList:
          this.props.CycleList,
      });
    }

    if (
      prevProps.AllLabs !==
      this.props.AllLabs
    ) {
      console.log(
        "Updated AllLabs:",
        this.props.AllLabs
      );

      this.setState(
        {
          AllLabs:
            this.props.AllLabs,
        },
        () => {
          this.applyFilters();
        }
      );
    }

    if (
      prevProps.AllLabs !==
        this.props.AllLabs ||
      prevProps.CycleList !==
        this.props.CycleList
    ) {
      console.log(
        "Filtering CycleList for participants"
      );

      const participantSchemes =
        new Set(
          (
            this.props.AllLabs || []
          ).flatMap(
            (lab) =>
              (lab.schemes || []).map(
                (scheme) =>
                  scheme.scheme_name
              )
          )
        );

      this.setState({
        CycleList:
          this.props.CycleList,

        filteredCycleList:
          Array.from(
            participantSchemes
          ),
      });
    }

    if (
      prevProps.partPaymentData !==
      this.props.partPaymentData
    ) {
      console.log(
        "API partPaymentData received:",
        this.props.partPaymentData
      );

      this.setState({
        localPartPaymentData:
          this.props.partPaymentData,
      });
    }

    if (
      prevProps.CSRList !==
      this.props.CSRList
    ) {
      console.log(
        "CSRList updated:",
        this.props.CSRList
      );

      console.log(
        "CSRList length:",
        this.props.CSRList
          ? this.props.CSRList.length
          : 0
      );
    }
  }

  applyFilters = () => {
    // Kept because the original component calls this method.
  };

  refreshPage = () => {
    this.fetchData(
      this.state.user_id
    );

    this.applyFilters();
  };

  normalizeValue = (
    value,
    fallback = ""
  ) => {
    if (
      value === null ||
      value === undefined ||
      value === "" ||
      value === "null"
    ) {
      return fallback;
    }

    return value;
  };

  render() {
    console.log(
      "Rendering table with data:",
      this.state.filteredLabs
    );

    const {
      AllLabs,
      partPaymentData,
      CSRList,
    } = this.props;

    const {
      CycleList,
    } = this.state;

    /**
     * =====================================================
     * CSR OPTIONS
     * =====================================================
     */

    const csrOptions = (
      CSRList || []
    ).map((username) => ({
      value: username,
      label: username,
    }));

    console.log(
      "CSRList from props:",
      CSRList
    );

    console.log(
      "CSR options:",
      csrOptions
    );

    /**
     * =====================================================
     * SCHEME HANDLING
     * =====================================================
     */

    const attachedSchemeIds =
      typeof partPaymentData?.scheme ===
      "string"
        ? partPaymentData.scheme
            .split(",")
            .map((s) => s.trim())
            .filter(Boolean)
        : Array.isArray(
            partPaymentData?.scheme
          )
        ? partPaymentData.scheme
        : [];

    const schemeOptions = (
      CycleList || []
    )
      .filter((scheme) => {
        // Build the combined Scheme/Cycle ID.
        // Example: 12-45
        const comboId =
          String(scheme.scheme_id) +
          "-" +
          String(scheme.id);

        const isActive =
          scheme.status &&
          String(scheme.status)
            .toLowerCase() ===
            "active";

        const isAlreadyAttached =
          attachedSchemeIds.includes(
            comboId
          );

        return (
          isActive ||
          isAlreadyAttached
        );
      })
      .map((scheme) => {
        const isActive =
          scheme.status &&
          String(scheme.status)
            .toLowerCase() ===
            "active";

        const comboId =
          String(scheme.scheme_id) +
          "-" +
          String(scheme.id);

        return {
          value: comboId,

          label:
            "(Scheme Name: " +
            scheme.scheme_name +
            ") - (Cycle Number: " +
            scheme.cycle_no +
            ")" +
            (isActive
              ? ""
              : " [Inactive]"),

          scheme_id:
            scheme.scheme_id,

          cycle_id: scheme.id,
        };
      });

    console.log(
      "Mapped scheme options:",
      schemeOptions
    );

    /**
     * =====================================================
     * PAYMENT CALCULATION
     * =====================================================
     */

    const totalPayable =
      parseFloat(
        partPaymentData?.price
      ) || 0;

    const rawPartPaymentAmount =
      partPaymentData?.part_payment_amount;

    const alreadyPaid =
      rawPartPaymentAmount === null ||
      rawPartPaymentAmount ===
        undefined ||
      rawPartPaymentAmount === "" ||
      rawPartPaymentAmount ===
        "null"
        ? 0
        : parseFloat(
            rawPartPaymentAmount
          ) || 0;

    const backendRemaining =
      partPaymentData?.remaining_amount !==
        null &&
      partPaymentData?.remaining_amount !==
        undefined &&
      partPaymentData?.remaining_amount !==
        "" &&
      partPaymentData?.remaining_amount !==
        "null"
        ? parseFloat(
            partPaymentData.remaining_amount
          )
        : null;

    let previousRemaining = 0;

    /**
     * If no previous payment exists,
     * entire payable amount remains.
     */
    if (alreadyPaid === 0) {
      previousRemaining =
        totalPayable;
    } else {
      /**
       * If backend has remaining amount,
       * use it.
       *
       * Otherwise calculate it.
       */
      if (
        backendRemaining !== null &&
        !isNaN(backendRemaining)
      ) {
        previousRemaining =
          Math.max(
            backendRemaining,
            0
          );
      } else {
        previousRemaining =
          Math.max(
            totalPayable -
              alreadyPaid,
            0
          );
      }
    }

    console.log(
      "========== PAYMENT CALCULATION =========="
    );

    console.log(
      "Total Payable:",
      totalPayable
    );

    console.log(
      "Part Payment Amount:",
      rawPartPaymentAmount
    );

    console.log(
      "Already Paid:",
      alreadyPaid
    );

    console.log(
      "Backend Remaining:",
      backendRemaining
    );

    console.log(
      "FINAL Remaining Amount:",
      previousRemaining
    );

    console.log(
      "=========================================="
    );

    /**
     * =====================================================
     * FORM INITIAL VALUES
     * =====================================================
     */

    const initialValues = {
      photoFile: null,

      photoUrl:
        this.normalizeValue(
          partPaymentData?.photo
        ),

      participant:
        this.state
          .selectedParticipant?.id ||
        "",

      paydate:
        this.normalizeValue(
          partPaymentData?.paydate
        ),

      payment_status:
        this.normalizeValue(
          partPaymentData?.payment_status
        ),

      payment_settlement:
        this.normalizeValue(
          partPaymentData?.payment_settlement
        ),

      priceBeforeDiscount:
        this.normalizeValue(
          partPaymentData?.priceBeforeDiscount
        ),

      paymentmethod:
        this.normalizeValue(
          partPaymentData?.paymentmethod
        ),

      discountAmount:
        this.normalizeValue(
          partPaymentData?.discountAmount
        ),

      taxDeduction:
        this.normalizeValue(
          partPaymentData?.taxDeduction
        ),

      scheme:
        attachedSchemeIds,

      remaining_amount:
        previousRemaining,

      /**
       * New amount paid in this transaction.
       */
      new_paid_amount: "",

      purchase_order_copy: "",

      price:
        this.normalizeValue(
          partPaymentData?.price
        ),

      discount:
        this.normalizeValue(
          partPaymentData?.discount,
          "-"
        ),

      /**
       * CSR / Received By
       */
      receivedby:
        this.normalizeValue(
          partPaymentData?.receivedby
        ),

      /**
       * NEW COMMENTS FIELD
       *
       * Existing comments will be loaded
       * if backend returns csrcomments.
       */
      csrcomments:
        this.normalizeValue(
          partPaymentData?.csrcomments
        ),

      added_by:
        this.state.user_id || "",
    };

    /**
     * =====================================================
     * VALIDATION
     * =====================================================
     */

    const validationSchema =
      Yup.object().shape({
        participant:
          Yup.string().required(
            "Participant is required"
          ),

        payment_status:
          Yup.string().required(
            "Payment status is required"
          ),

        paydate:
          Yup.string().required(
            "Date is required"
          ),

        paymentmethod:
          Yup.string().required(
            "Payment Method is required"
          ),

        receivedby:
          Yup.string().required(
            "Received By is required"
          ),

        photoFile:
          Yup.mixed()
            .test(
              "required",
              "Deposit Slip is required",
              function (value) {
                return (
                  !!value ||
                  !!this.parent.photoUrl
                );
              }
            )
            .test(
              "fileSize",
              "File too large",
              (value) =>
                !value ||
                (value &&
                  value.size <=
                    2 *
                      1024 *
                      1024)
            )
            .test(
              "fileType",
              "Unsupported file format",
              (value) =>
                !value ||
                [
                  "image/jpeg",
                  "image/png",
                  "image/jpg",
                  "application/pdf",
                ].includes(
                  value.type
                )
            ),

        discountAmount:
          Yup.number().nullable(),

        taxDeduction:
          Yup.number().nullable(),

        price: Yup.number()
          .required(
            "Price is required"
          )
          .min(
            0,
            "Price cannot be negative"
          ),

        /**
         * Comments are optional.
         *
         * If you want them required,
         * change this to:
         *
         * csrcomments: Yup.string().required(
         *   "Comments are required"
         * ),
         */
        csrcomments:
          Yup.string().nullable(),

        new_paid_amount:
          Yup.number()
            .typeError(
              "Enter a valid amount"
            )
            .required(
              "New paid amount is required"
            )
            .moreThan(
              0,
              "Amount must be greater than 0"
            )
            .max(
              previousRemaining,
              "Cannot exceed the remaining balance of " +
                previousRemaining.toLocaleString()
            ),
      });

    return (
      <React.Fragment>
        <div
          className="page-content"
          style={{
            width: "80%",
            margin: "100px auto",
          }}
        >
          <MetaTags>
            <title>
              Remaining Payment for
              Participant | Lab Management
            </title>
          </MetaTags>

          <Container fluid>
            <h2 className="page-title">
              {this.state
                .selectedParticipant
                ?.name ||
                "Unknown"}{" "}
              - Remaining Payment
            </h2>

            {/* =================================================
                PAYMENT TYPE
                ================================================= */}

            <div className="mt-3 mb-3">
              <Label>
                Payment Type
              </Label>

              <Input
                type="select"
                value={
                  this.state
                    .paymentType
                }
                onChange={(e) => {
                  const type =
                    e.target.value;

                  const participant =
                    this.state
                      .selectedParticipant;

                  this.setState({
                    paymentType:
                      type,
                  });

                  if (
                    type === "new"
                  ) {
                    this.props.history.push(
                      {
                        pathname:
                          "/" +
                          this.state
                            .organization_name +
                          "/csrAllpartcicpantpaymentmodal/" +
                          participant.id,

                        state: {
                          selectedParticipant:
                            participant,
                        },
                      }
                    );
                  }
                }}
              >
                <option value="new">
                  New Payment
                </option>

                <option value="partial">
                  Partial Payment
                </option>
              </Input>
            </div>

            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <Formik
                      enableReinitialize
                      initialValues={
                        initialValues
                      }
                      validationSchema={
                        validationSchema
                      }
                      onSubmit={async (
                        values,
                        {
                          setSubmitting,
                          resetForm,
                        }
                      ) => {
                        try {
                          const userId =
                            this.state
                              .user_id;

                          const newPaidAmount =
                            parseFloat(
                              values.new_paid_amount ||
                                0
                            );

                          /**
                           * Current balance before
                           * this payment.
                           */
                          const currentRemaining =
                            previousRemaining;

                          /**
                           * Balance after payment.
                           */
                          let remainingAmount =
                            currentRemaining -
                            newPaidAmount;

                          if (
                            remainingAmount <
                            0
                          ) {
                            remainingAmount = 0;
                          }

                          /**
                           * Settlement status.
                           */
                          let settlement =
                            values.payment_settlement ||
                            "Part";

                          if (
                            remainingAmount ===
                            0
                          ) {
                            settlement =
                              "Full";
                          } else {
                            settlement =
                              "Part";
                          }

                          /**
                           * Build API payload.
                           */
                          const payload = {
                            ...values,

                            payment_settlement:
                              settlement,

                            /**
                             * Backend expects
                             * comma-separated schemes.
                             */
                            scheme:
                              Array.isArray(
                                values.scheme
                              )
                                ? values.scheme.join(
                                    ","
                                  )
                                : values.scheme,

                            price:
                              parseFloat(
                                values.price ||
                                  0
                              ).toFixed(2),

                            /**
                             * Payment made in
                             * this transaction.
                             */
                            part_payment_amount:
                              newPaidAmount.toFixed(
                                2
                              ),

                            /**
                             * Balance after
                             * this transaction.
                             */
                            remaining_amount:
                              remainingAmount.toFixed(
                                2
                              ),

                            added_by:
                              userId,

                            photo:
                              values.photoFile ||
                              values.photoUrl,

                            /**
                             * CSR / Received By
                             */
                            receivedby:
                              values.receivedby,

                            /**
                             * NEW COMMENTS
                             *
                             * This is sent to the
                             * backend as csrcomments.
                             */
                            csrcomments:
                              values.csrcomments ||
                              "",
                          };

                          /**
                           * Do not send this
                           * frontend-only field.
                           */
                          delete payload.new_paid_amount;

                          console.log(
                            "Submitting payment payload:",
                            payload
                          );

                          await this.props.onAddremainingpayment(
                            payload
                          );

                          this.setState(
                            {
                              successMessage:
                                "Participant's payment updated successfully",
                            },
                            () => {
                              setTimeout(
                                () =>
                                  this.setState(
                                    {
                                      successMessage:
                                        "",
                                    }
                                  ),
                                3000
                              );
                            }
                          );

                          /**
                           * Refresh payment
                           * information.
                           */
                          setTimeout(
                            () => {
                              this.props.onGetpartpayment(
                                this
                                  .state
                                  .selectedParticipant
                                  ?.id
                              );
                            },
                            500
                          );

                          resetForm();
                        } catch (error) {
                          console.error(
                            "Error adding payment:",
                            error
                          );

                          this.setState({
                            successMessage:
                              "Failed to save payment. Please try again.",
                          });
                        }

                        setSubmitting(
                          false
                        );

                        setTimeout(
                          () =>
                            this.props.ongetcyclelist(
                              this.state
                                .user_id
                            ),
                          1000
                        );
                      }}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        setFieldValue,
                      }) => (
                        <Form>
                          {/* =================================================
                              SUCCESS MESSAGE
                              ================================================= */}

                          {this.state
                            .successMessage && (
                            <Alert
                              color="success"
                              className="mb-4"
                            >
                              {
                                this
                                  .state
                                  .successMessage
                              }
                            </Alert>
                          )}

                          {/* =================================================
                              SCHEME
                              ================================================= */}

                          <Row>
                            <Col>
                              <Label>
                                Scheme
                              </Label>

                              <Select
                                name="scheme"
                                isMulti
                                isDisabled
                                options={
                                  schemeOptions
                                }
                                value={schemeOptions.filter(
                                  (
                                    option
                                  ) =>
                                    values.scheme.includes(
                                      option.value
                                    )
                                )}
                                onChange={(
                                  selectedOptions
                                ) => {
                                  const selectedValues =
                                    selectedOptions
                                      ? selectedOptions.map(
                                          (
                                            o
                                          ) =>
                                            o.value
                                        )
                                      : [];

                                  setFieldValue(
                                    "scheme",
                                    selectedValues
                                  );

                                  const totalPrice =
                                    selectedValues.reduce(
                                      (
                                        sum,
                                        combinedId
                                      ) => {
                                        const parts =
                                          String(
                                            combinedId
                                          ).split(
                                            "-"
                                          );

                                        const cycleId =
                                          Number(
                                            parts[1]
                                          );

                                        const scheme =
                                          (
                                            this
                                              .props
                                              .CycleList ||
                                            []
                                          ).find(
                                            (
                                              s
                                            ) =>
                                              s.id ===
                                              cycleId
                                          );

                                        return (
                                          sum +
                                          (scheme
                                            ? parseFloat(
                                                scheme.price ||
                                                  0
                                              )
                                            : 0)
                                        );
                                      },
                                      0
                                    );

                                  setFieldValue(
                                    "priceBeforeDiscount",
                                    totalPrice.toFixed(
                                      2
                                    )
                                  );

                                  setFieldValue(
                                    "price",
                                    totalPrice.toFixed(
                                      2
                                    )
                                  );
                                }}
                              />

                              <ErrorMessage
                                name="scheme"
                                component="div"
                                className="invalid-feedback"
                              />
                            </Col>
                          </Row>

                          {/* =================================================
                              PRICE
                              ================================================= */}

                          <Row className="mt-3">
                            <Col>
                              <Label>
                                Payable after
                                Discount &
                                Tax Deduction
                              </Label>

                              <Field name="price">
                                {({
                                  field,
                                }) => (
                                  <input
                                    {...field}
                                    type="text"
                                    className="form-control"
                                    value={new Intl.NumberFormat(
                                      "en-PK",
                                      {
                                        style:
                                          "currency",
                                        currency:
                                          "PKR",
                                      }
                                    ).format(
                                      values.price ||
                                        0
                                    )}
                                    readOnly
                                    style={{
                                      backgroundColor:
                                        "#e9ecef",
                                    }}
                                  />
                                )}
                              </Field>
                            </Col>
                          </Row>

                          {/* =================================================
                              REMAINING AMOUNT
                              ================================================= */}

                          <Row className="mt-3">
                            <Col>
                              <Label>
                                Remaining Amount
                              </Label>

                              <input
                                type="text"
                                className="form-control"
                                readOnly
                                style={{
                                  backgroundColor:
                                    "#e9ecef",
                                }}
                                value={new Intl.NumberFormat(
                                  "en-PK",
                                  {
                                    style:
                                      "currency",
                                    currency:
                                      "PKR",
                                  }
                                ).format(
                                  previousRemaining ||
                                    0
                                )}
                              />

                              <small
                                style={{
                                  color:
                                    "#6c757d",
                                }}
                              >
                                Current
                                outstanding
                                balance before
                                this payment.
                              </small>
                            </Col>
                          </Row>

                          {/* =================================================
                              NEW PAID AMOUNT
                              ================================================= */}

                          <Row className="mt-3">
                            <Col>
                              <Label>
                                New Paid Amount
                              </Label>

                              <Field name="new_paid_amount">
                                {({
                                  field,
                                }) => (
                                  <input
                                    type="number"
                                    min="0"
                                    max={
                                      previousRemaining
                                    }
                                    step="0.01"
                                    className={
                                      "form-control " +
                                      (errors.new_paid_amount &&
                                      touched.new_paid_amount
                                        ? "is-invalid"
                                        : "")
                                    }
                                    value={
                                      field.value
                                    }
                                    onChange={(
                                      e
                                    ) =>
                                      setFieldValue(
                                        "new_paid_amount",
                                        e
                                          .target
                                          .value
                                      )
                                    }
                                  />
                                )}
                              </Field>

                              <small
                                style={{
                                  color:
                                    "#6c757d",
                                }}
                              >
                                Maximum
                                payment:{" "}
                                {new Intl.NumberFormat(
                                  "en-PK",
                                  {
                                    style:
                                      "currency",
                                    currency:
                                      "PKR",
                                  }
                                ).format(
                                  previousRemaining ||
                                    0
                                )}
                              </small>

                              <ErrorMessage
                                name="new_paid_amount"
                                component="div"
                                className="invalid-feedback"
                              />
                            </Col>
                          </Row>

                          {/* =================================================
                              PAY DATE
                              ================================================= */}

                          <Row className="mt-3">
                            <Col>
                              <Label>
                                Pay Date
                              </Label>

                              <Field
                                name="paydate"
                                type="date"
                                className="form-control"
                              />

                              <ErrorMessage
                                name="paydate"
                                component="div"
                                className="invalid-feedback"
                              />
                            </Col>
                          </Row>

                          {/* =================================================
                              PAY COPY
                              ================================================= */}

                          <Row className="mt-3">
                            <Col>
                              <Label>
                                Pay Copy
                              </Label>

                              {!values.photoFile &&
                                values.photoUrl && (
                                  <div className="mb-2">
                                    <a
                                      href={
                                        "https://externalqcapi.com/" +
                                        values.photoUrl
                                      }
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      View
                                      uploaded
                                      slip
                                    </a>

                                    <div>
                                      <small
                                        style={{
                                          color:
                                            "#6c757d",
                                        }}
                                      >
                                        Leave
                                        this
                                        empty
                                        to keep
                                        the
                                        slip
                                        above,
                                        or
                                        choose
                                        a new
                                        file
                                        to
                                        replace
                                        it.
                                      </small>
                                    </div>
                                  </div>
                                )}

                              <Input
                                id="formFile"
                                name="photoFile"
                                type="file"
                                accept=".jpg,.jpeg,.png,.pdf"
                                onChange={(
                                  event
                                ) =>
                                  setFieldValue(
                                    "photoFile",
                                    event
                                      .currentTarget
                                      .files[0]
                                  )
                                }
                                className={
                                  "form-control " +
                                  (errors.photoFile &&
                                  touched.photoFile
                                    ? "is-invalid"
                                    : "")
                                }
                              />

                              <small
                                style={{
                                  color:
                                    "#007bff",
                                }}
                              >
                                Only JPEG,
                                PNG, or PDF
                                files up
                                to 2MB are
                                allowed.
                              </small>

                              <ErrorMessage
                                name="photoFile"
                                component="div"
                                className="invalid-feedback"
                              />
                            </Col>
                          </Row>

                          {/* =================================================
                              PAYMENT METHOD
                              ================================================= */}

                          <Row className="mt-3">
                            <Col>
                              <Label>
                                Payment Method
                              </Label>

                              <Select
                                name="paymentmethod"
                                options={[
                                  {
                                    value:
                                      "Online",
                                    label:
                                      "Online",
                                  },
                                  {
                                    value:
                                      "Cheque",
                                    label:
                                      "Cheque",
                                  },
                                  {
                                    value:
                                      "Cash",
                                    label:
                                      "Cash",
                                  },
                                ]}
                                value={
                                  values.paymentmethod
                                    ? {
                                        value:
                                          values.paymentmethod,
                                        label:
                                          values.paymentmethod,
                                      }
                                    : null
                                }
                                onChange={(
                                  option
                                ) =>
                                  setFieldValue(
                                    "paymentmethod",
                                    option?.value ||
                                      ""
                                  )
                                }
                                className={
                                  errors.paymentmethod &&
                                  touched.paymentmethod
                                    ? "is-invalid"
                                    : ""
                                }
                              />

                              <ErrorMessage
                                name="paymentmethod"
                                component="div"
                                className="invalid-feedback"
                              />
                            </Col>
                          </Row>

                          {/* =================================================
                              RECEIVED BY / CSR
                              ================================================= */}

                          <Row className="mt-3">
                            <Col>
                              <Label>
                                Received By
                              </Label>

                              <Select
                                name="receivedby"
                                options={
                                  csrOptions
                                }
                                placeholder="Select CSR"
                                isClearable
                                isSearchable
                                value={
                                  values.receivedby
                                    ? csrOptions.find(
                                        (
                                          option
                                        ) =>
                                          option.value ===
                                          values.receivedby
                                      ) || {
                                        value:
                                          values.receivedby,
                                        label:
                                          values.receivedby,
                                      }
                                    : null
                                }
                                onChange={(
                                  option
                                ) =>
                                  setFieldValue(
                                    "receivedby",
                                    option?.value ||
                                      ""
                                  )
                                }
                                className={
                                  errors.receivedby &&
                                  touched.receivedby
                                    ? "is-invalid"
                                    : ""
                                }
                              />

                              <ErrorMessage
                                name="receivedby"
                                component="div"
                                className="invalid-feedback"
                              />

                              {!CSRList ||
                                (CSRList.length ===
                                  0 && (
                                  <small
                                    style={{
                                      color:
                                        "#dc3545",
                                    }}
                                  >
                                    No CSR
                                    found.
                                    Check
                                    the CSR
                                    API
                                    response
                                    and
                                    AddPayment
                                    reducer.
                                  </small>
                                ))}
                            </Col>
                          </Row>

                          {/* =================================================
                              COMMENTS
                              ================================================= */}

                          <Row className="mt-3">
                            <Col>
                              <Label htmlFor="csrcomments">
                                Comments
                              </Label>

                              <Field
                                as="textarea"
                                id="csrcomments"
                                name="csrcomments"
                                rows="4"
                                placeholder="Enter comments..."
                                className={
                                  "form-control " +
                                  (errors.csrcomments &&
                                  touched.csrcomments
                                    ? "is-invalid"
                                    : "")
                                }
                              />

                              <ErrorMessage
                                name="csrcomments"
                                component="div"
                                className="invalid-feedback"
                              />

                              <small
                                style={{
                                  color:
                                    "#6c757d",
                                }}
                              >
                                Add any
                                additional
                                comments or
                                notes related
                                to this
                                payment.
                              </small>
                            </Col>
                          </Row>

                          {/* =================================================
                              BUTTONS
                              ================================================= */}

                          <div className="d-flex justify-content-end mt-4">
                            <Button
                              color="primary"
                              type="submit"
                            >
                              Save
                            </Button>

                            <Button
                              color="secondary"
                              type="button"
                              onClick={() =>
                                this.props.history.goBack()
                              }
                              className="ms-2"
                            >
                              Cancel
                            </Button>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

PartialPayment.propTypes = {
  match: PropTypes.object,

  selectedParticipant:
    PropTypes.object,

  AllLabs:
    PropTypes.array,

  className:
    PropTypes.any,

  history:
    PropTypes.any,

  onAddremainingpayment:
    PropTypes.func,

  participantId:
    PropTypes.func,

  ongetcyclelist:
    PropTypes.func,

  onGetpartpayment:
    PropTypes.func,

  onGetParticipantPayment:
    PropTypes.func,

  CSRList:
    PropTypes.array,

  PaymentSchemeList:
    PropTypes.array,

  location: PropTypes.shape({
    search:
      PropTypes.string,

    state: PropTypes.shape({
      selectedParticipant:
        PropTypes.object,
    }),
  }),

  CycleList:
    PropTypes.array,

  participant:
    PropTypes.any,

  partPaymentData:
    PropTypes.shape({
      id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),

      participant:
        PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
        ]),

      photo:
        PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.object,
        ]),

      paydate:
        PropTypes.string,

      priceBeforeDiscount:
        PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
        ]),

      payment_status:
        PropTypes.string,

      payment_settlement:
        PropTypes.string,

      paymentmethod:
        PropTypes.string,

      discountAmount:
        PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
        ]),

      taxDeduction:
        PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
        ]),

      scheme:
        PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.array,
        ]),

      part_payment_amount:
        PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
        ]),

      remaining_amount:
        PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
        ]),

      price:
        PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
        ]),

      discount:
        PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
        ]),

      receivedby:
        PropTypes.string,

      csrcomments:
        PropTypes.string,
    }),
};

const mapStateToProps = ({
  Account,
  registrationAdmin,
  CycleList,
  AddPayment,
}) => {
  return {
    userID:
      Account?.userID || null,

    AllLabs:
      registrationAdmin?.AllLabs || [],

    approvedLabs:
      registrationAdmin?.approvedLabs || [],

    CycleList:
      CycleList?.CycleList || [],

    partPaymentData:
      registrationAdmin?.partpayment ||
      null,

    /**
     * CSR list comes from AddPayment reducer.
     */
    CSRList:
      AddPayment?.csr_staff || [],

    PaymentSchemeList:
      AddPayment?.PaymentSchemeList || [],
  };
};

const mapDispatchToProps = (
  dispatch
) => ({
  onGetpartpayment: (id) =>
    dispatch(
      getpartpayment(id)
    ),

  ongetcyclelist: (id) =>
    dispatch(
      getcyclelist(id)
    ),

  onAddremainingpayment: (
    payment
  ) =>
    dispatch(
      addremainingpayment(payment)
    ),

  /**
   * Populates csr_staff.
   */
  onGetParticipantPayment: (
    id
  ) =>
    dispatch(
      getParticipantSchemelist(id)
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PartialPayment));
